import { render, staticRenderFns } from "./ProList.vue?vue&type=template&id=4e2affbe&scoped=true"
import script from "./ProList.vue?vue&type=script&lang=js"
export * from "./ProList.vue?vue&type=script&lang=js"
import style0 from "./ProList.vue?vue&type=style&index=0&id=4e2affbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2affbe",
  null
  
)

export default component.exports